import { render, staticRenderFns } from "./addResponsibilities.vue?vue&type=template&id=31a9f184&"
import script from "./addResponsibilities.vue?vue&type=script&lang=js&"
export * from "./addResponsibilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports